/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} White_Upper_Squirrel_GripInputs */

const fr_white_upper_squirrel_grip = /** @type {(inputs: White_Upper_Squirrel_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les utilisateurs peuvent voir cette catégorie dans l'app`)
};

/**

* @param {White_Upper_Squirrel_GripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const white_upper_squirrel_grip = /** @type {((inputs?: White_Upper_Squirrel_GripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<White_Upper_Squirrel_GripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_white_upper_squirrel_grip(inputs)
});